var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Cleaning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 49.94v2.4A7.49 7.49 0 0057.74 62h-16.6A4.14 4.14 0 0137 59.71c-.08-.16-.27-.65-.29-.71h-.16c-3.43 0-6.62-2.79-7.41-6.48-.38-1.72-1-7.62 7.17-11.32 4.37-2.2 21.54-11.37 21.75-11.48a7.36 7.36 0 003.83-8.23c-.53-2.72-2.52-5.49-5.78-5.49H45.22L18 58h3a2.91 2.91 0 013 2.86V62H7v-1a3 3 0 013-3h3.11L43 12h13.09c4.79 0 8.69 3.5 9.7 8.7a11.37 11.37 0 01-5.88 12.53c-.3.15-17.41 9.37-21.84 11.57-3.77 1.72-5.56 4.21-5 6.86A4 4 0 0036.59 55h1C40 49.65 47.78 44 59.46 44H61c5.66 0 8 2.75 8 5.94zm-4.94 3.53a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Cleaning.034ec229.svg";
export { SvgE4Cleaning as ReactComponent };